import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { JsmGsConfigProviderEntrypointProps } from './JsmGsConfigProvider.entrypoint.types.tsx';

type QueuesConfigProviderEntrypointComponent = EntryPointComponent<
	{},
	{},
	JsmGsConfigProviderEntrypointProps,
	{} | null
>;

export const queuesConfigProviderEntrypoint: EntryPoint<
	QueuesConfigProviderEntrypointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<QueuesConfigProviderEntrypointComponent>(
		/* webpackChunkName: "ai-rovo-actions-jsm-gs-queues-provider" */ './QueuesConfigProviderEntry.tsx',
	),
	getPreloadProps: () => ({}),
});
